import { where } from 'firebase/firestore'

import FirestoreService from '../../firestoreService'
import { getConvertedData } from '../../../models/interface.helper'

import { AssignTicketsModal } from '../../../models/assigned-tickets/assigned-tickets.model'

import { IAssignedTicket } from '../../../models/assigned-tickets/assigned-tickets.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getByEventId = async (eventId: string) => {
  const assignedTicketsInDb: IAssignedTicket[] = []

  const eventRegisteredUsersSnaps = await FirestoreService.filterItems(
    COLLECTIONS.ASSIGNED_TICKETS.NAME,
    [where(COLLECTIONS.ASSIGNED_TICKETS.FIELDS.EVENT_DOC_ID, '==', eventId)]
  )

  eventRegisteredUsersSnaps.docs.forEach((currDoc) => {
    assignedTicketsInDb.push(
      getConvertedData(AssignTicketsModal.fromFirestoreDoc(currDoc).toObject())
    )
  })

  return assignedTicketsInDb
}

const AssignedTicketsService = {
  getByEventId,
}
export default AssignedTicketsService
